// extracted by mini-css-extract-plugin
export default {"rulesModal":"Rules_rulesModal__5P0X9","active":"Rules_active__BokJX","rulesModalContent":"Rules_rulesModalContent__mHP9d"};